
import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import { useSelector } from 'react-redux'



const PrivateRoute = ({ component: Component, ...rest }) => {
    const isLoggedIn = useSelector(state => state.user.isLoggedIn && state.user.jwt !== null)

    return (
        <Route {...rest} render={(props) => (
            isLoggedIn === true
              ? <Component {...props} />
              : <Redirect to='/signin' />
          )} />
    )
}

export default PrivateRoute
